import { render, staticRenderFns } from "./SelectProvincia.vue?vue&type=template&id=24002580"
import script from "./SelectProvincia.vue?vue&type=script&lang=js"
export * from "./SelectProvincia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports